module.exports = __webpack_public_path__ + "static/media/aiDesignerTemplate4.9531e3d4.png";